import { CloseOutline18Icon } from "@vygruppen/spor-icon-react";
import { ButtonTextContainer } from "features/CenterContent/shared/Tabs/TabsCenter";
import {
  ActiveTab,
  InActiveTab,
} from "features/CenterContent/shared/Tabs/TabsStyle";
import {
  TrainTab,
  useTabsContext,
} from "features/CenterContent/shared/Tabs/useTabsContext";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { CrossButton } from "shared/components/buttons/CrossButton";
import { Text } from "shared/components/Spor";
import * as ROUTES from "shared/utils/routes";

export const TrainTabElement = ({
  trainTabs,
  index,
}: {
  trainTabs: TrainTab;
  index: number;
}) => {
  const { activeIdTabs, setActiveIdTabs } = useTabsContext();
  const { trainNumber, trainDate } = useParams();
  const navigate = useNavigate();
  const selected =
    trainTabs.trainNumber === trainNumber && trainTabs.trainDate === trainDate;
  const TabElement = selected ? ActiveTab : InActiveTab;
  return (
    <TabElement
      title={`${trainTabs.trainNumber} - ${trainTabs.trainDate}`}
      key={index}
      onClick={(event) => {
        event.preventDefault();
        void navigate(
          generatePath(ROUTES.TRAIN, {
            countryCode: trainTabs.countryCode,
            trainNumber: trainTabs.trainNumber,
            trainDate: trainTabs.trainDate,
          }),
        );
      }}
      style={{
        padding: "4px 10px",
        borderRadius: "6px 6px 0px 0px",
      }}
    >
      <ButtonTextContainer>
        <Text variant="sm" margin="auto">
          {trainTabs.trainNumber || ""}
        </Text>
        <CrossButton
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            if (selected) {
              if (activeIdTabs.length === 1) {
                sessionStorage.removeItem("openTabs");
                void navigate(ROUTES.DASHBOARD);
              } else {
                const prevTab = (
                  activeIdTabs[index - 1]
                    ? activeIdTabs[index - 1]
                    : activeIdTabs[index + 1]
                ) as TrainTab;
                if (
                  prevTab &&
                  prevTab.type === "train" &&
                  prevTab.trainNumber
                ) {
                  const {
                    trainNumber: prevTrainNumber,
                    trainDate: prevTrainDate,
                    countryCode,
                  } = prevTab;
                  void navigate(
                    generatePath(ROUTES.TRAIN, {
                      countryCode,
                      trainNumber: prevTrainNumber,
                      trainDate: prevTrainDate,
                    }),
                  );
                }
              }
            }
            setActiveIdTabs((prevArr: any) => {
              prevArr.splice(index, 1);
              return Array.from(prevArr);
            });
          }}
        >
          <CloseOutline18Icon color="icon" marginLeft="4px" />
        </CrossButton>
      </ButtonTextContainer>
    </TabElement>
  );
};
